import { ArrayParam, JsonParam, StringParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'
import { EXTERNAL_PRODUCTS_STATUS_TITLE } from '@app/pages/ExternalProductsCatalogPage/сonstans'

import type { ExternalProductsCatalogDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<ExternalProductsCatalogDataSource> = {
  name: 'Товар',
  code: 'Код товара',
  trend: 'Направление',
  trendId: 'Код направления',
  purchasingGroup: 'ГЗ',
  purchasingGroupId: 'Код ГЗ',
  commodityGroup: 'Тов. группа',
  commodityGroupId: 'Код тов. группы',
  category: 'Категория',
  categoryId: 'Код категории',
  subcategory: 'Подкатегория',
  subcategoryId: 'Код подкатегории',
  barcodes: 'Штрих-код',
  status: 'Статус',
  isCHTM: 'ЧТМ',
  isEPP: 'EPP',
  productCodes: 'Код товара',
  volume: 'Объем/вес',
  brand: 'Бренд',
  manufacturer: 'Производитель',
  regionManufacturer: 'Страна произв.',
  categoryEggs: 'Категория яиц',
  shell: 'Оболочка',
  fatContentOrFortress: 'Жирность/крепость, %',
  productForm: 'Форма выпуска',
  packaging: 'Упаковка'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.name]: StringParam,
  [FILTERS_PARAMS_KEYS.trendIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.purchasingGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.commodityGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.categoriesIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.subcategoriesIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.status]: ArrayParam,
  [FILTERS_PARAMS_KEYS.productCodes]: StringParam,
  [FILTERS_PARAMS_KEYS.isMatchedWithProduct]: StringParam,
  [FILTERS_PARAMS_KEYS.isConfirmed]: StringParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ExternalProductsCatalogDataSource> = {
  'table-name': StringParam,
  'table-code': StringParam,
  'table-trend': StringParam,
  'table-trendId': StringParam,
  'table-purchasingGroup': StringParam,
  'table-purchasingGroupId': StringParam,
  'table-commodityGroup': StringParam,
  'table-commodityGroupId': StringParam,
  'table-category': StringParam,
  'table-categoryId': StringParam,
  'table-subcategory': StringParam,
  'table-subcategoryId': StringParam,
  'table-barcodes': StringParam,
  'table-status': JsonParam,
  'table-productCodes': StringParam,
  'table-volume': StringParam,
  'table-brand': StringParam,
  'table-manufacturer': StringParam,
  'table-regionManufacturer': StringParam,
  'table-categoryEggs': StringParam,
  'table-shell': StringParam,
  'table-fatContentOrFortress': StringParam,
  'table-productForm': StringParam,
  'table-packaging': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const options = Object.entries(EXTERNAL_PRODUCTS_STATUS_TITLE).map(([key, value]) => ({
  label: value,
  value: key
}))

export const columnsSearchSchema: ColumnTableSearchSchema<ExternalProductsCatalogDataSource> = {
  name: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  code: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  trend: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  trendId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  category: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  categoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategory: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  barcodes: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  status: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options } },
  productCodes: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  volume: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  brand: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  manufacturer: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  regionManufacturer: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  categoryEggs: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  shell: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  fatContentOrFortress: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  productForm: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  packaging: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
